import { render } from "./PromptModal.vue?vue&type=template&id=6280e0d2&scoped=true"
import script from "./PromptModal.vue?vue&type=script&lang=js"
export * from "./PromptModal.vue?vue&type=script&lang=js"

import "./PromptModal.vue?vue&type=style&index=0&id=6280e0d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6280e0d2"]])

export default __exports__